import React from 'react';

interface Props {
    avatarId: number | null;
    avatarName?: string | null;
    isSelected: boolean;
    onSelected?: (avatarId: number | null) => void;
    className?: string;
}
export default class DecorationPreviewItem extends React.PureComponent<Props> {
    handleClick = (evt: React.MouseEvent): void => {
        const { onSelected, avatarId } = this.props;

        if (onSelected) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onSelected(avatarId);
        }
    };

    render() {
        const { isSelected, children, avatarName, className } = this.props;

        let classNames: Array<string> = ['ct-decoration-manager__item'];
        if (className) {
            classNames.push(className);
        }
        if (isSelected) {
            classNames.push('ct-decoration-manager__item--current');
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                <div className="ct-decoration-manager__item-inner">{children}</div>
                {avatarName && <div className="ct-decoration-manager__item-label">{avatarName}</div>}
            </div>
        );
    }
}
